import React, { useEffect, useMemo, useRef, useState } from "react";

export default function SearchBar({
  placeholder = "Search…",
  initialValue = "",
  minChars = 2,
  debounceMs = 250,
  fetchResults,        // (q: string) => Promise<Array<{id,title,subtitle,right,icon,href?,raw?}>>
  onSelect,
  wrapperClass = "prediction_search_bar"
}) {
  const [q, setQ] = useState(initialValue);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [active, setActive] = useState(-1);
  const boxRef = useRef(null);
  const reqId = useRef(0);
  const timer = useRef(null);

  // Close on outside click
  useEffect(() => {
    function onDocClick(e) {
      if (!boxRef.current?.contains(e.target)) setOpen(false);
    }
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, []);

  // Debounced querying
  useEffect(() => {
    
    if (timer.current) clearTimeout(timer.current);
    if (!fetchResults) return;

    const query = q.trim();
    if (query.length < minChars) {
      setItems([]);
      setLoading(false);
      return;
    }

    timer.current = setTimeout(async () => {
      setLoading(true);
      setOpen(true);
      const id = ++reqId.current;
      try {
        const res = await fetchResults(query);
        if (id === reqId.current) setItems(Array.isArray(res) ? res : []);
      } finally {
        if (id === reqId.current) setLoading(false);
      }
    }, debounceMs);

    return () => clearTimeout(timer.current);
  }, [q, debounceMs, minChars, fetchResults]);

  console.log("items>>>>>>",items);

  function handleKeyDown(e) {
    if (!open) return;
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setActive((i) => Math.min(i + 1, items.length - 1));
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setActive((i) => Math.max(i - 1, 0));
    } else if (e.key === "Enter") {
      e.preventDefault();
      const item = items[active] || items[0];
      if (item) select(item);
    } else if (e.key === "Escape") {
      setOpen(false);
    }
  }

  function select(item) {
    setOpen(false);
    setActive(-1);
    if (onSelect) onSelect(item);
    // Optional: if item has href we can navigate
    if (item.href) window.location.href = item.href;
  }

  const highlight = (text, query) => {
    if (!text) return null;
    if (!query) return text;
    const idx = text.toLowerCase().indexOf(query.toLowerCase());
    if (idx === -1) return text;
    return (
      <>
        {text.slice(0, idx)}
        <mark className="smart-search_mark">{text.slice(idx, idx + query.length)}</mark>
        {text.slice(idx + query.length)}
      </>
    );
  };

  return (
     <div className={wrapperClass}> 
        <div className="smart-search" ref={boxRef}>
        <i className="smart-search_icon fa fa-search" aria-hidden="true" />
        <input
            className="smart-search_input"
            type="text"
            placeholder={placeholder}
            value={q}
            onChange={(e) => setQ(e.target.value)}
            onFocus={() => q.trim().length >= minChars && setOpen(true)}
            onKeyDown={handleKeyDown}
        />
        {q && (
            <button
            className="smart-search_clear"
            aria-label="Clear"
            onClick={() => { setQ(""); setItems([]); setActive(-1); }}
            >
            ×
            </button>
        )}

        {open && (
            <div className="smart-search_panel">
            {loading && <div className="smart-search_state">Searching…</div>}
            {!loading && items.length === 0 && (
                <div className="smart-search_state">No results</div>
            )}
            {!loading && items.map((it, i) => (
                
                <button
                key={it.id || i}
                className={`smart-search_item ${i === active ? "is-active" : ""}`}
                onMouseEnter={() => setActive(i)}
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => select(it)}
                role="option"
                aria-selected={i === active}
                >
                <div className="smart-search_left">
                    <div className="smart-search_text">
                    <div className="">
                        {/* {highlight(it.title, q)} */}
                        {it.title}
                        
                    </div>
                    {!!it.subtitle && (
                        <div className="smart-search_sub">{it.subtitle}</div>
                    )}
                    </div>
                </div>
                {!!it.right && <div className="smart-search_right">{it.right}</div>}
                </button>
            ))}
            </div>
        )}
        </div>
    </div>
  );
}
